import { render } from "./PageDetailExperts.vue?vue&type=template&id=0d0e0ad2"
import script from "./PageDetailExperts.vue?vue&type=script&lang=js"
export * from "./PageDetailExperts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__